import { Classes, Tab, Tabs } from "@blueprintjs/core"
import CustomCard from "components/Atoms/CustomCard"
import { useDmsTripDetailsQuery } from "generated/graphql"
import React from "react"
import { useParams } from "react-router-dom"
import classNames from "utils/classNames"
import ActivityPlan from "./ActivityPlan"
import Loading from "./Loading"

const TripDetail = () => {
  const { id } = useParams()
  const { data } = useDmsTripDetailsQuery({
    variables: { tripIdInt: Number(id), tripId: id },
  })

  return (
    <CustomCard className="m-4">
      <div className="p-2" style={{ background: "#F5F5F5" }}>
        <div className={Classes.TEXT_LARGE}>
          Gate pass number - {data?.tripDetails?.uuid?.split("-")[0]}
        </div>
        <div className={classNames(Classes.TEXT_SMALL, Classes.TEXT_MUTED)}>
          Driver name - {data?.tripDetails?.aggregator?.fullName}
        </div>
      </div>
      <div className="mt-6 bg-white border-legacy rounded p-3">
        <Tabs id="tripDetailTabs" defaultSelectedTabId="loading" large={true}>
          <Tab
            className="text-center"
            id="loading"
            title="Loading details"
            panel={<Loading tripId={id} trip={data?.tripDetails} />}
          />
          <Tab
            className="text-center"
            id="activityPlank"
            title="Activity plan"
            panel={<ActivityPlan tripId={Number(id)} />}
          />
        </Tabs>
      </div>
    </CustomCard>
  )
}

export default TripDetail
